/* beadboo — standalone collar builder (/pages/design, layout bb-builder).
   Флоу: Style (вертикальная рулетка) → Charms (2 слота) → Tag (живое превью)
   → POST /cart/add.js → Congratulations. Line item properties и логика превью
   тега = 1-в-1 с PDP-конструктором (beadboo-customizer.js — source of truth). */
(function () {
  'use strict';

  var root = document.getElementById('bb-builder');
  if (!root || root.dataset.bbldInit) return;
  root.dataset.bbldInit = '1';

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── элементы ─────────────────────────────────────────────────────────── */
  var steps = {};
  $$('[data-bbld-step]').forEach(function (el) { steps[el.dataset.bbldStep] = el; });
  var roul = $('[data-bbld-roul]');
  var slides = $$('[data-bbld-slide]');
  if (!roul || !slides.length) return;

  var railDots = $$('[data-bbld-raildot]');
  var trackFill = $('[data-bbld-fill]');
  var trackDots = $$('[data-bbld-dot]');
  var backBtn = $('[data-bbld-back]');
  var bar = $('[data-bbld-bar]');
  var cta = $('[data-bbld-cta]');
  var note = $('[data-bbld-note]');
  var pickedEl = $('[data-bbld-picked]');
  var slotEls = $$('[data-bbld-slot]');
  var charmBtns = $$('[data-bbld-charm]');
  var miniImg = $('[data-bbld-minimg]');
  var miniName = $('[data-bbld-mininame]');
  var stage = $('[data-bbld-stage]');
  var tagImg = $('[data-bbld-tagimg]');
  var tagText = $('[data-bbld-tagtext]');
  var fontBtns = $$('[data-bbld-font]');
  var fontPicked = $('[data-bbld-fontpicked]');
  var sideBtns = $$('[data-bbld-side]');
  var backTypeBtns = $$('[data-bbld-backtype]');
  var nameInput = $('[data-bbld-input="name"]');
  var backInput = $('[data-bbld-input="back"]');
  var sizeBtns = $$('[data-bbld-size]');
  var guideDialog = $('[data-bbld-guide]');
  var confetti = $('[data-bbld-confetti]');

  var parseMap = function (raw) { try { return JSON.parse(raw || '{}'); } catch (e) { return {}; } };
  var styleMap = parseMap(stage.dataset.bbldStylemap);
  var inkMap = parseMap(stage.dataset.bbldInkmap);
  var shadowMap = parseMap(stage.dataset.bbldShadowmap);
  var backMap = parseMap(stage.dataset.bbldBackmap);

  /* имя чарма → src его картинки (для слотов) */
  var charmImgs = {};
  charmBtns.forEach(function (b) {
    var img = b.querySelector('img');
    if (img) charmImgs[b.dataset.bbldCharm] = img.currentSrc || img.src;
  });

  /* ── состояние ────────────────────────────────────────────────────────── */
  var state = {
    step: 'style',
    idx: 0,
    style: '', variant: '', price: '',
    charm1: '', charm2: '', activeSlot: 1,
    font: 'Cherry Bomb One', fontStack: "'Cherry Bomb One', cursive",
    side: 'front', backType: 'Phone',
    name: '', back: '', size: ''
  };

  var CTA_LABEL = {
    style: 'Choose This Style',
    charms: 'Done with Charms',
    tag: 'Next · Size',
    size: 'Finish My Design'
  };

  var FILL = { style: 6, charms: 34, tag: 62, size: 92, done: 100 };
  var ORDER = ['style', 'charms', 'tag', 'size', 'done'];

  /* ── навигация по шагам ───────────────────────────────────────────────── */
  function charmsDone() { return !!(state.charm1 && state.charm2); }
  function tagDone() { return !!(state.name.trim() && state.back.trim()); }

  function setNote(text) {
    if (!note) return;
    note.textContent = text || '';
    note.hidden = !text;
  }

  function refreshCta() {
    if (state.step === 'done') return;
    cta.classList.remove('is-busy');
    var locked = false;
    var label = CTA_LABEL[state.step];
    if (state.step === 'charms') locked = !charmsDone();
    if (state.step === 'tag') locked = !tagDone();
    if (state.step === 'size') {
      locked = !state.size;
      label += ' · ' + (state.price || '');
    }
    cta.textContent = label;
    cta.classList.toggle('is-locked', locked);
    cta.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }

  function render(step, backwards) {
    var prev = state.step;
    state.step = step;
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; });
    var el = steps[step];
    if (!reduced && prev !== step) {
      el.classList.remove('is-in', 'is-in-back');
      void el.offsetWidth;
      el.classList.add(backwards ? 'is-in-back' : 'is-in');
    }
    if (trackFill) trackFill.style.width = FILL[step] + '%';
    var stepIdx = ORDER.indexOf(step);
    trackDots.forEach(function (d) {
      var k = d.dataset.bbldDot;
      var i = ORDER.indexOf(k);
      d.classList.toggle('is-now', k === step);
      d.classList.toggle('is-done', i < stepIdx || step === 'done');
      var reachable = step !== 'done' && i < stepIdx;
      d.setAttribute('aria-disabled', reachable ? 'false' : 'true');
    });
    backBtn.hidden = step === 'style' || step === 'done';
    bar.hidden = step === 'done';
    setNote('');
    refreshCta();
    if (step === 'tag') renderTag();
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function goForward(step) {
    render(step, false);
    try { history.pushState({ bbld: step }, ''); } catch (e) { /* noop */ }
  }

  function goBack() {
    var i = ORDER.indexOf(state.step);
    if (i > 0) render(ORDER[i - 1], true);
  }

  window.addEventListener('popstate', function (e) {
    var s = e.state && e.state.bbld;
    if (!s || !steps[s]) return;
    var backwards = ORDER.indexOf(s) < ORDER.indexOf(state.step);
    render(s, backwards);
  });
  try { history.replaceState({ bbld: 'style' }, ''); } catch (e) { /* noop */ }

  backBtn.addEventListener('click', function () {
    if (history.state && history.state.bbld) history.back();
    else goBack();
  });

  trackDots.forEach(function (d) {
    d.addEventListener('click', function () {
      if (d.getAttribute('aria-disabled') === 'true') return;
      goForward(d.dataset.bbldDot);
    });
  });

  /* ── ШАГ 1 · рулетка ──────────────────────────────────────────────────── */
  function setIdx(i) {
    if (i === state.idx && slides[i].dataset.seen) return;
    state.idx = i;
    slides[i].dataset.seen = '1';
    railDots.forEach(function (d, n) {
      d.classList.toggle('is-on', n === i);
      d.setAttribute('aria-selected', n === i ? 'true' : 'false');
    });
  }

  /* фактический шаг между слайдами (слайды ниже 100% — снизу выглядывает
     следующий стиль, поэтому шаг ≠ clientHeight рулетки) */
  function slideStep() {
    if (slides.length > 1) {
      var step = slides[1].offsetTop - slides[0].offsetTop;
      if (step > 0) return step;
    }
    return Math.max(1, roul.clientHeight);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) setIdx(parseInt(en.target.dataset.idx, 10) || 0);
      });
    }, { root: roul, threshold: 0.55 });
    slides.forEach(function (s) { io.observe(s); });
  }

  railDots.forEach(function (d) {
    d.addEventListener('click', function () {
      var i = parseInt(d.dataset.bbldRaildot, 10) || 0;
      roul.scrollTo({ top: i * slideStep(), behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  /* точки-галерея внутри каждого слайда (шаг = фактическое расстояние между
     карточками: они уже вьюпорта, по бокам выглядывают соседние фото) */
  slides.forEach(function (slide) {
    var gal = $('[data-bbld-gal]', slide);
    var dots = $('[data-bbld-galdots]', slide);
    if (!gal || !dots) return;
    var items = $$('i', dots);
    var cards = $$('.bbld-gal__item', gal);
    var raf = 0;
    gal.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var step = cards.length > 1 ? Math.max(1, cards[1].offsetLeft - cards[0].offsetLeft) : Math.max(1, gal.clientWidth);
        var i = Math.round(gal.scrollLeft / step);
        items.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      });
    }, { passive: true });
  });

  /* выбор стиля = слайд, на котором остановилась рулетка. Индекс считаем от
     scrollTop в момент нажатия, а не от IO: observer может не успеть за
     фликом (или быть затроттлен), а позиция скролла — факт. */
  function currentIdx() {
    var i = Math.round(roul.scrollTop / slideStep());
    return Math.min(slides.length - 1, Math.max(0, i));
  }

  function chooseStyle() {
    setIdx(currentIdx());
    var slide = slides[state.idx];
    state.style = slide.dataset.style || '';
    state.variant = slide.dataset.variant || '';
    state.price = slide.dataset.price || '';
    applyStyle();
    goForward('charms');
  }

  /* ── ШАГ 2 · чармы ────────────────────────────────────────────────────── */
  function slotVal(n) { return n === 1 ? state.charm1 : state.charm2; }

  function setSlotVal(n, v) {
    if (n === 1) state.charm1 = v; else state.charm2 = v;
  }

  function paintSlot(n) {
    var el = slotEls[n - 1];
    var v = slotVal(n);
    var side = n === 1 ? 'Left' : 'Right';
    el.querySelectorAll('img, .bbld-slot__magic, .bbld-slot__none').forEach(function (x) { x.remove(); });
    el.classList.toggle('is-filled', !!v);
    if (!v) {
      el.setAttribute('aria-label', side + ' charm — empty');
    } else if (v === 'Let us pick') {
      var m = document.createElement('span');
      m.className = 'bbld-slot__magic';
      m.textContent = '✨';
      el.appendChild(m);
      el.setAttribute('aria-label', side + ' charm — let us pick');
    } else if (v === 'None') {
      var o = document.createElement('span');
      o.className = 'bbld-slot__none';
      el.appendChild(o);
      el.setAttribute('aria-label', side + ' charm — no charm');
    } else {
      var img = document.createElement('img');
      img.src = charmImgs[v] || '';
      img.alt = '';
      img.width = 56;
      img.height = 56;
      el.appendChild(img);
      el.setAttribute('aria-label', side + ' charm — ' + v);
    }
  }

  function paintCharms() {
    paintSlot(1);
    paintSlot(2);
    slotEls.forEach(function (el, i) {
      el.classList.toggle('is-active', state.step !== 'done' && i + 1 === state.activeSlot && !charmsDone());
    });
    charmBtns.forEach(function (b) {
      var v = b.dataset.bbldCharm;
      b.classList.toggle('is-picked', v === state.charm1 || v === state.charm2);
    });
    var picked = (state.charm1 ? 1 : 0) + (state.charm2 ? 1 : 0);
    if (pickedEl) pickedEl.textContent = picked + ' of 2 picked';
    refreshCta();
  }

  charmBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.dataset.bbldCharm;
      if (b.hasAttribute('data-bbld-fillboth')) {
        state.charm1 = v;
        state.charm2 = v;
      } else {
        setSlotVal(state.activeSlot, v);
        state.activeSlot = !slotVal(1) ? 1 : (!slotVal(2) ? 2 : (state.activeSlot === 1 ? 2 : 1));
      }
      paintCharms();
      setNote('');
    });
  });

  slotEls.forEach(function (el, i) {
    el.addEventListener('click', function () {
      var n = i + 1;
      if (slotVal(n)) setSlotVal(n, '');
      state.activeSlot = n;
      paintCharms();
    });
  });

  /* ── ШАГ 3 · тег (порт логики beadboo-customizer.js) ──────────────────── */
  function applyStyle() {
    var url = styleMap[state.style];
    var ink = inkMap[state.style] || '#fff';
    var shadow = shadowMap[state.style] || 'rgba(44,71,112,.45)';
    if (url) {
      stage.classList.add('has-photo');
      stage.style.setProperty('--bbld-tagsrc', 'url("' + url + '")');
      syncTagFace();
    }
    tagText.style.color = ink;
    tagText.style.setProperty('--bbld-shadow', shadow);
    if (miniImg && url) miniImg.src = url;
    if (miniName) {
      miniName.style.color = ink;
      miniName.style.textShadow = '0 1px 2px ' + shadow;
    }
  }

  /* Polka Pup: зад без точек — на стороне Back картинка из backmap */
  function syncTagFace() {
    if (!state.style) return;
    var url = state.side === 'back' && backMap[state.style] ? backMap[state.style] : styleMap[state.style];
    if (url) tagImg.src = url;
  }

  /* «858 905-4793» → ['858', '905-4793'] (10 цифр или 11 с ведущей 1) */
  function splitPhone(raw) {
    var d = raw.replace(/\D/g, '');
    if (d.length === 11 && d[0] === '1') d = d.slice(1);
    if (d.length !== 10) return null;
    return [d.slice(0, 3), d.slice(3, 6) + '-' + d.slice(6)];
  }

  /* ширина текста текущим шрифтом при 100px через canvas — иммунна к
     rotateY-флипу и моменту загрузки шрифта (канон PDP) */
  var wCanvas, vCanvas;
  function measureTextWidth(el, text) {
    try {
      var cs = getComputedStyle(el);
      wCanvas = wCanvas || document.createElement('canvas');
      var ctx = wCanvas.getContext('2d');
      ctx.font = '400 100px ' + cs.fontFamily;
      return ctx.measureText(text || 'LUNA').width;
    } catch (e) { return 0; }
  }

  /* оптический вертикальный центр глифов (bubble-шрифты «оседают» вниз) */
  function verticalTrim(el, text) {
    try {
      var cs = getComputedStyle(el);
      vCanvas = vCanvas || document.createElement('canvas');
      var ctx = vCanvas.getContext('2d');
      ctx.font = '400 100px ' + cs.fontFamily;
      ctx.textBaseline = 'alphabetic';
      var m = ctx.measureText(text || 'LUNA');
      var fa = m.fontBoundingBoxAscent, fd = m.fontBoundingBoxDescent;
      var aa = m.actualBoundingBoxAscent, ad = m.actualBoundingBoxDescent;
      if ([fa, fd, aa, ad].some(function (v) { return typeof v !== 'number' || isNaN(v); })) return 0;
      return (fa - fd - aa + ad) / 2 / 100;
    } catch (e) { return 0; }
  }

  function renderTag() {
    var name = state.name.trim();
    var back = state.back.trim();
    var shown = state.side === 'front'
      ? (name || 'LUNA')
      : (back || (state.backType === 'Phone' ? '858 905-4793' : 'Microchipped'));
    var phone = state.side === 'back' && state.backType === 'Phone' ? splitPhone(shown) : null;
    tagText.classList.toggle('bbld-tag__text--two', !!phone);
    if (phone) {
      tagText.textContent = '';
      var area = document.createElement('span');
      area.textContent = phone[0];
      var rest = document.createElement('span');
      rest.textContent = phone[1];
      tagText.appendChild(area);
      tagText.appendChild(rest);
    } else {
      tagText.textContent = shown;
    }
    /* строка держится в ~62% ширины косточки (fit-формула PDP) */
    var frac = 0.62;
    var measure = phone ? phone[1] : shown;
    var w100 = measureTextWidth(tagText, measure) + Math.max(0, measure.length - 1) * 2;
    var ts = w100 > 0 ? Math.min(64, Math.max(16, (frac * 30000) / w100)) : 64;
    tagText.style.setProperty('--bbld-ts', ts);
    var px = (ts * stage.clientWidth) / 300;
    var k = phone ? 0 : verticalTrim(tagText, measure);
    tagText.style.setProperty('--bbld-vshift', (-k * px).toFixed(2) + 'px');
  }

  function flipTo(side) {
    if (side === state.side) return;
    state.side = side;
    sideBtns.forEach(function (b) {
      var on = b.dataset.bbldSide === side;
      b.classList.toggle('is-picked', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (reduced) {
      syncTagFace();
      renderTag();
      return;
    }
    stage.classList.remove('is-flip-in');
    stage.classList.add('is-flip-out');
    setTimeout(function () {
      syncTagFace();
      renderTag();
      stage.classList.remove('is-flip-out');
      stage.classList.add('is-flip-in');
      setTimeout(function () { stage.classList.remove('is-flip-in'); }, 330);
    }, 190);
  }

  sideBtns.forEach(function (b) {
    b.addEventListener('click', function () { flipTo(b.dataset.bbldSide); });
  });

  fontBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.font = b.dataset.bbldFont;
      state.fontStack = b.dataset.bbldFontstack;
      fontBtns.forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-picked', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (fontPicked) fontPicked.textContent = state.font;
      tagText.style.fontFamily = state.fontStack;
      if (miniName) miniName.style.fontFamily = state.fontStack;
      renderTag();
    });
  });

  backTypeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.backType = b.dataset.bbldBacktype;
      backTypeBtns.forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-picked', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var isPhone = state.backType === 'Phone';
      backInput.placeholder = isPhone ? '858 905-4793' : 'Microchipped';
      backInput.setAttribute('inputmode', isPhone ? 'tel' : 'text');
      if (state.side === 'back') renderTag();
    });
  });

  function bindInput(input, key) {
    var count = $('[data-bbld-count="' + key + '"]');
    var err = $('[data-bbld-error="' + key + '"]');
    input.addEventListener('input', function () {
      state[key] = input.value;
      if (count) count.textContent = input.value.length + '/12';
      if (err && input.value.trim()) {
        err.hidden = true;
        input.closest('.bbld-field').classList.remove('is-bad');
      }
      if (key === 'name' && state.side === 'front') renderTag();
      if (key === 'back' && state.side === 'back') renderTag();
      refreshCta();
      setNote('');
    });
  }
  bindInput(nameInput, 'name');
  bindInput(backInput, 'back');

  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.dataset.bbldSize;
      sizeBtns.forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-picked', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var err = $('[data-bbld-error="size"]');
      if (err) err.hidden = true;
      refreshCta();
      setNote('');
    });
  });

  /* модалка «How to measure» */
  var guideOpen = $('[data-bbld-guide-open]');
  var guideClose = $('[data-bbld-guide-close]');
  if (guideDialog && guideOpen) {
    guideOpen.addEventListener('click', function () {
      if (typeof guideDialog.showModal === 'function') guideDialog.showModal();
      else guideDialog.setAttribute('open', '');
    });
    if (guideClose) guideClose.addEventListener('click', function () { guideDialog.close(); });
    guideDialog.addEventListener('click', function (e) {
      if (e.target === guideDialog) guideDialog.close(); // тап по подложке
    });
  }

  window.addEventListener('resize', function () {
    if (state.step === 'tag') renderTag();
  });
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      if (state.step === 'tag') renderTag();
    });
  }

  /* ── финиш: валидация + добавление в корзину ──────────────────────────── */
  function showTagErrors() {
    var firstBad = null;
    [['name', nameInput], ['back', backInput]].forEach(function (pair) {
      var bad = !state[pair[0]].trim();
      var err = $('[data-bbld-error="' + pair[0] + '"]');
      if (err) err.hidden = !bad;
      pair[1].closest('.bbld-field').classList.toggle('is-bad', bad);
      if (bad && !firstBad) firstBad = pair[1];
    });
    if (firstBad) firstBad.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }

  function shake(el) {
    el.classList.remove('bbld-shake');
    void el.offsetWidth;
    el.classList.add('bbld-shake');
  }

  function addToCart() {
    cta.classList.add('is-busy');
    cta.innerHTML = '<span class="bbld-cta__spin" aria-hidden="true"></span> Adding…';
    var payload = {
      items: [{
        id: parseInt(state.variant, 10),
        quantity: 1,
        properties: {
          'Left charm': state.charm1,
          'Right charm': state.charm2,
          'Font': state.font,
          'Pet name': state.name.trim(),
          'Tag back': state.backType + ': ' + state.back.trim(),
          'Size': state.size
        }
      }]
    };
    fetch((root.dataset.addUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'add failed'); });
      return res.json();
    }).then(function () {
      fillRecap();
      goForward('done');
      if (confetti && !reduced) {
        setTimeout(function () { confetti.classList.add('is-run'); }, 120);
      }
    }).catch(function () {
      cta.classList.remove('is-busy');
      refreshCta();
      setNote('Hmm, the cart didn’t answer — please try again \u{1F43E}');
      shake(cta);
    });
  }

  function fillRecap() {
    var name = state.name.trim();
    var sub = $('[data-bbld-donesub]');
    if (sub && name) sub.textContent = name + '’s collar is in your cart.';
    var map = {
      style: state.style + (state.price ? ' · ' + state.price : ''),
      charms: state.charm1 === state.charm2 ? state.charm1 + ' × 2' : state.charm1 + ' · ' + state.charm2,
      front: name + ' · ' + state.font,
      back: state.backType + ': ' + state.back.trim(),
      size: state.size.split(' (')[0]
    };
    Object.keys(map).forEach(function (k) {
      var el = $('[data-bbld-recap="' + k + '"]');
      if (el) el.textContent = map[k];
    });
  }

  /* ── главная кнопка ───────────────────────────────────────────────────── */
  cta.addEventListener('click', function () {
    if (state.step === 'style') {
      chooseStyle();
      return;
    }
    if (state.step === 'charms') {
      if (!charmsDone()) {
        setNote('Fill both spots — pick a charm or “No charm” ✨');
        shake(cta);
        return;
      }
      goForward('tag');
      return;
    }
    if (state.step === 'tag') {
      if (!tagDone()) {
        showTagErrors();
        setNote('A couple of finishing touches left \u{1F43E}');
        shake(cta);
        return;
      }
      goForward('size');
      return;
    }
    if (state.step === 'size') {
      if (!state.size) {
        var err = $('[data-bbld-error="size"]');
        if (err) err.hidden = false;
        setNote('Pick a size to finish \u{1F436}');
        shake(cta);
        return;
      }
      if (cta.classList.contains('is-busy')) return;
      addToCart();
    }
  });

  var restart = $('[data-bbld-restart]');
  if (restart) restart.addEventListener('click', function () { window.location.reload(); });

  /* ── старт ────────────────────────────────────────────────────────────── */
  paintCharms();
  render('style', false);
})();
